export default "__VITE_ASSET__D1Z4yGg4__"